import React, { useState, useEffect } from "react";

import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { Button, Typography } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import { REACT_APP_PROD_URL } from "../../services/configs";
import * as Sentry from "@sentry/react";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";

export default function AllNotifications() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  const [notifs, setNotifs] = useState(null);
  const [doubleClick, setDoubleClick] = useState(false);

  const token = useSelector((state) => state.trading.TOKEN);

  // for pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    getAllNotifications();
  }, [page, rowsPerPage]);

  function getAllNotifications() {
    if (token) {
      fetcher(
        `/v1/notifications?sortBy=createdAt&direction=DESC&page=${
          page + 1
        }&pageSize=${rowsPerPage}`
      )
        .then((data) => {
          if (data.notifications) {
            setNotifs(data);
          }
          // console.log("Notifications", data);
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
      // console.log("Getting notifications");
    }
  }

  function markAllRead() {
    if (notifs.unReadNotifications !== 0) {
      fetcher(`/v1/markAllAsRead`, { method: "POST" })
        .then((res) => {
          // console.log(res);
          getAllNotifications();
          setDoubleClick(false);
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
      // console.log("Marking all notifications as read");
    }
  }

  return (
    <div className={classes.container}>
      <Typography
        style={{ marginBottom: "20px", fontSize: "40px", fontWeight: "bold" }}
      >
        All Notifications
      </Typography>

      <div className={classes.paddedContainer}>
        {notifs ? (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "15px",
            }}
          >
            <Button
              style={{
                fontWeight: "bold",
                color: "white",
              }}
              variant="contained"
              color="primary"
              onClick={() => {
                setDoubleClick(true);
                markAllRead();
              }}
              disabled={doubleClick || notifs.unReadNotifications === 0}
            >
              Mark all as read
            </Button>
          </div>
        ) : null}
        <TableContainer component="div">
          <Table aria-label="STOCKS TABLE">
            <TableHead>
              <TableRow className={classes.tableHeadText}>
                <TableCell className={classes.tableHeadText} align="left">
                  DATE & TIME
                </TableCell>
                <TableCell className={classes.tableHeadText} align="left">
                  TITLE
                </TableCell>
                <TableCell className={classes.tableHeadText} align="left">
                  MESSAGE
                </TableCell>
                <TableCell className={classes.tableHeadText} align="left">
                  STATUS
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notifs
                ? notifs.notifications.content.map((row) => (
                    <TableRow key={row.orderId} className={classes.bodyRows}>
                      <TableCell
                        align="left"
                        className={classes.bodyTextStyles}
                      >
                        {row.createdAt.slice(8, 10)}.{row.createdAt.slice(5, 7)}
                        .{row.createdAt.slice(0, 4)}{" "}
                        {row.createdAt.slice(11, 16)}
                      </TableCell>
                      <TableCell
                        className={classes.bodyTextStyles}
                        align="left"
                      >
                        {row.title}
                      </TableCell>
                      <TableCell
                        className={classes.bodyTextStyles}
                        align="left"
                      >
                        {row.notificationMessage}
                      </TableCell>
                      <TableCell
                        className={classes.bodyTextStyles}
                        align="left"
                      >
                        {row.isActive ? "Unread" : "Read"}
                      </TableCell>
                    </TableRow>
                  ))
                : null}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={notifs ? notifs.notifications.totalElements : 10}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      // minWidth: "450px",
      maxWidth: "450px",
    },
    width: "95%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  paddedContainer: {
    marginTop: "30px",
    padding: "40px",
    background: theme.palette.type === "dark" ? "#151828" : "white",
  },
  tableHeadText: {
    fontWeight: "bold",
  },
}));
